import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers/RootReducer";

const initialState = {};

const middleware = [thunk];

export const store = createStore(
  reducers,
  initialState,
  applyMiddleware(...middleware)
);
